<template>
  <div class="co-container-sm px-4 pb-20 pt-[3.75rem]">
    <div class="te-mentor-reason-banner">
      <div class="flex flex-col items-center bg-co-gray-50 px-8 py-7 md:flex-row">
        <div class="te-icon-wrap mb-5 md:mb-0">
          <div class="te-icon flex flex-col items-center justify-center rounded-full bg-co-primary-500 font-bold text-co-gray-50">
            <span class="te-icon-text">
              通過率
            </span>
            <span class="te-icon-num">10<span class="te-icon-num-text">%</span></span>
          </div>
        </div>
        <div class="ml-0 md:ml-10">
          <h2 class="co-display-7 mb-4 text-center font-bold md:text-left">
            メンターが実務レベルで<br class="block md:hidden">サポートできる理由
          </h2>
          <p class="mb-0">
            テックアカデミーのメンターは全員、実務経験のある現役の
            <slot name="mentorType">
              エンジニア
            </slot>
            のみを採用しています。採用過程には、カリキュラムをサポートできる実力を判断するスキルチェック、適切なコミュニケーション能力と教える能力を判断する面接を行っており、通過率はたったの10%ほど。この狭き門を通過したメンターだからこそ実務レベルの学びを提供できているのです。
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.te-mentor-reason-banner {
  padding: 5px;
  background: linear-gradient(135deg, #0f89a3 0%, #0b5770 100%);
  .te-icon-wrap {
    .te-icon {
      min-width: 160px;
      max-width: 160px;
      min-height: 160px;
      max-height: 160px;
      line-height: 1;
      .te-icon-text {
        font-size: 22px;
      }
      .te-icon-num {
        font-size: 60px;
      }
      .te-icon-num-text {
        font-size: 30px;
      }
    }
  }
}
</style>
